// extracted by mini-css-extract-plugin
export default {"modalWrapper":"PuzzelChat_modalWrapper__N99Mx","title":"PuzzelChat_title__dcB-R","casesList":"PuzzelChat_casesList__s5zgs"};